"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportCategoriesContextProvider = void 0;
var React = require("react");
var utils_1 = require("../../utils");
var urls_1 = require("../../urls");
var iterUtils_1 = require("../../components/lib/iterUtils");
var initialState = {
    isOpen: false,
    isReady: false,
    project_choices: [],
    selected_project: undefined,
    category_choices: [],
    selected_categories: [],
    selected_tags: [],
};
var ImportCategoriesContext = React.createContext(__assign(__assign({}, initialState), { openDialog: undefined, closeDialog: undefined, onProjectSelect: undefined, onCategorySelect: undefined, onTagSelect: undefined, onSave: undefined }));
exports.default = ImportCategoriesContext;
var ImportCategoriesContextProvider = (function (_super) {
    __extends(ImportCategoriesContextProvider, _super);
    function ImportCategoriesContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, initialState);
        return _this;
    }
    ImportCategoriesContextProvider.prototype.getUrl = function () {
        return this.props.is_control_action ?
            urls_1.Urls.admin_copy_ca_categories :
            urls_1.Urls.admin_copy_categories;
    };
    ImportCategoriesContextProvider.prototype.fetchChoices = function (project_id) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(this.getUrl(), this.props.project_id), {
            type: "GET",
            contentType: "application/json",
            data: { project_id: project_id },
            complete: ajaxErrorHandler,
        }).done(function (result) {
            self.setState({
                project_choices: [utils_1.emptyChoice].concat(result.project_choices),
                category_choices: result.category_choices,
                isReady: true,
            });
        });
    };
    ImportCategoriesContextProvider.prototype.openDialog = function () {
        this.setState({
            isOpen: true,
            isReady: false,
        });
        this.fetchChoices();
    };
    ImportCategoriesContextProvider.prototype.closeDialog = function () {
        this.setState({
            isOpen: false,
            isReady: false,
            selected_project: undefined,
            selected_tags: [],
            selected_categories: [],
        });
    };
    ImportCategoriesContextProvider.prototype.onProjectSelect = function (project_id) {
        var id_ = parseInt(project_id);
        if (isNaN(id_)) {
            this.setState({
                selected_project: null,
                category_choices: [],
            });
        }
        else {
            this.setState({
                selected_project: project_id
            });
            this.fetchChoices(id_);
        }
    };
    ImportCategoriesContextProvider.prototype.onCategorySelect = function (category, checked) {
        this.setState(function (prev) {
            var selected_categories = prev.selected_categories;
            var selected_tags = prev.selected_tags;
            var selectionIndex = prev.selected_categories.indexOf(category.value);
            var alreadySelected = selectionIndex >= 0;
            if (checked && !alreadySelected) {
                selected_categories.push(category.value);
            }
            else if (!checked && alreadySelected) {
                selected_categories.splice(selectionIndex, 1);
            }
            category.children.forEach(function (tag) {
                var tagSelectionIndex = selected_tags.indexOf(tag.value);
                var tagAlreadySelected = tagSelectionIndex >= 0;
                if (checked && !tagAlreadySelected) {
                    selected_tags.push(tag.value);
                }
                else if (!checked && tagAlreadySelected) {
                    selected_tags.splice(tagSelectionIndex, 1);
                }
            });
            return {
                selected_categories: selected_categories,
                selected_tags: selected_tags,
            };
        });
    };
    ImportCategoriesContextProvider.prototype.onTagSelect = function (category, tag, checked) {
        this.setState(function (prev) {
            var selected_categories = prev.selected_categories;
            var selected_tags = prev.selected_tags;
            if (checked && !(0, iterUtils_1.contains)(selected_categories, category.value)) {
                selected_categories.push(category.value);
            }
            var selectionIndex = prev.selected_tags.indexOf(tag.value);
            var alreadySelected = selectionIndex >= 0;
            if (checked && !alreadySelected) {
                selected_tags.push(tag.value);
            }
            else if (!checked && alreadySelected) {
                selected_tags.splice(selectionIndex, 1);
            }
            return {
                selected_categories: selected_categories,
                selected_tags: selected_tags,
            };
        });
    };
    ImportCategoriesContextProvider.prototype.onSave = function () {
        var self = this;
        return $.ajax((0, urls_1.resolve)(this.getUrl(), this.props.project_id), {
            type: "POST",
            data: JSON.stringify({
                other_project: this.state.selected_project,
                selected_categories: this.state.selected_categories,
                selected_tags: this.state.selected_tags,
            }),
            complete: ajaxErrorHandler,
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        }).done(function () {
            return self.setState({
                isOpen: false,
                isReady: false,
                selected_project: null,
                project_choices: [],
                category_choices: [],
            });
        });
    };
    ImportCategoriesContextProvider.prototype.render = function () {
        return (React.createElement(ImportCategoriesContext.Provider, { value: __assign(__assign({}, this.state), { openDialog: this.openDialog.bind(this), closeDialog: this.closeDialog.bind(this), onProjectSelect: this.onProjectSelect.bind(this), onCategorySelect: this.onCategorySelect.bind(this), onTagSelect: this.onTagSelect.bind(this), onSave: this.onSave.bind(this) }) }, this.props.children));
    };
    return ImportCategoriesContextProvider;
}(React.Component));
exports.ImportCategoriesContextProvider = ImportCategoriesContextProvider;
